import styled from 'styled-components';
import ContentEditable from 'react-contenteditable';
import {
  Link,
} from 'react-router-dom';

import {
  Flex,
  SVG,
} from 'web-styled';

export const Item = styled(Flex).attrs({
  align: 'center',
  shrink: 0,
  spacing: 10,
  justify: 'space-between',
})`
  margin: 0;
  width: 100%;
  padding: 10px 15px;
  border-bottom: 1px solid #ededed;

  & .is_hover_only {
    visibility: hidden;
  }

  &:hover {
    background: #fbfbfb;

    & .is_hover_only {
      visibility: visible;
    }
  }
`;

export const Name = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 5px;
  margin-left: -5px;
  color: ${props => props.theme.colors.link};
  border: 1px dashed transparent;
  font-size: 14px;
  line-height: 28px;

  & > div {
    margin-right: 8px;
  }
`;

export const EditableWrapper = styled(Flex).attrs({
  align: 'center',
  content: 'center',
  spacing: 8,
})`
  color: ${props => props.theme.colors.link};
  font-size: 14px;
  padding: 5px 5px;
  margin-left: -5px;
  border: 1px dashed ${props => props.theme.colors.primary};
  border-radius: 5px;
  outline: none;
`;

export const EditableName = styled(ContentEditable)`
  color: ${props => props.theme.colors.inputColor};
  font-size: 14px;
  line-height: 28px;
  outline: none;
`;

export const DocumentIcon = styled(SVG.Document).attrs(
  props => ({
    width: '18px',
    height: '18px',
    stroke: props.theme.colors.link,
  }),
)``;

export const Empty = styled(Flex).attrs({
  column: true,
  spacing: 10,
  align: 'center',
  justify: 'center',
})`
  width: 100%;
  height: 100%;
  color: #ccc;
  text-align: center;
`;
